import React from "react";
import { UnorderedList, ListItem } from "@vds/lists";
import {  ModalTitle } from "@vds/modals";
import { Body, Title,Micro } from "@vds/typography";
import { Button } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { useMediaQuery } from "react-responsive";
import {
    InternetGatewayModal as IGModal ,
    InternetGatewayModalBody,
    ButtonContainer } from "../FWA/EquipmentSection/styles";
import { MarginSpacerM, MarginSpacerXS } from "../styleTag";
import { TileContainer } from "@vds/tiles";
import { Icon } from "@vds/icons";
import { getImageLink } from "utils/imageUtils";
import styled from "styled-components";
import { getImageUrl } from "./GWJointOfferCard";
import { getImage } from "utils/imageUtils";

export const CustomTileContainer = styled.div`
  width:100%;
  position:relative;
  background-color:#f6f6f6;
  display:block !important;
  padding:1rem;
  border-radius:8px;
  @media (max-width: 767px){
    padding:0.5rem;
  }
`;

export const CustomCol=styled(Col)`
align-self:center;
`
export const CustomBody = styled.div`
  font-size:2rem !important;
  font-weight:700 !important;
  align-items:center !important;
  text-align: center !important;
`;

const ImageContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
position: relative;

@media (max-width: 767px){
  top: 0px;
  img{
    width:70px !important;
    height:70px !important;
    left: 13px;
  }
}
`

const CustomColTile = styled(Col)`
@media only screen and (max-width: 567px) {
  div.hxwwzR {
      -webkit-flex-basis: 40% !important;
      -ms-flex-preferred-size: 40% !important;
      flex-basis: 40% !important;
      max-width: 40% !important;
      display: block;
  }
}
`

export default function GWJointOfferModal(props) {

  
const isMobile = useMediaQuery({
  query: "(max-width: 545px)",
});


  return (
      <IGModal
        ariaLabel=""
        opened={props.showModal}
        onOpenedChange={props.setShowModal}
        zIndex={1000000}
        disableFocusLock= {true}
      >
        <ModalTitle>
          <Title size="large" bold={true}>
            <div dangerouslySetInnerHTML={{ __html: props?.aemContent.modalTitle }}></div>
          </Title>
        </ModalTitle>
          <InternetGatewayModalBody>
          <Grid colGutter={false} rowGutter={0} 
            colSizes={{
                mobile: 1,
                tablet: 2,
                desktop: 3,
            }}>
                <Row>
                  <CustomColTile colSizes={{ mobile: 1, tablet: 4, desktop: 5 }} className="custom-tile-containier">
                  <CustomTileContainer
                          padding="1rem"
                          aspectRatio="none"
                          backgroundColor="gray"
                        >
                          <ImageContainer>
                            <img
                              height= {"90"}
                              width={"90"}
                              //src={getImageUrl(props?.aemContent?.crownRouterImage, 90, 90)}
                              src={getImage(props?.aemContent?.crownRouterImage, 90, 90)}
                            />
                          </ImageContainer>
                          
                          <Body size="large" bold>
                              <div
                              dangerouslySetInnerHTML={{ __html: props?.aemContent?.routerHeading }}
                              ></div>
                            </Body>
                            <Body size={isMobile ? "medium" : "large"} color="#808080">
                              <div
                              dangerouslySetInnerHTML={{ __html: props?.aemContent?.routerSubheading }}
                              ></div>
                             </Body>
                        </CustomTileContainer>
                </CustomColTile>
                <CustomCol colSizes={{ mobile: 1, tablet: 4, desktop: 1 }} className="custom-tile">
                  <div style={{ textAlign: 'center'}}>
                      <CustomBody>+</CustomBody>
                  </div>
                </CustomCol>
                <CustomColTile colSizes={{ mobile: 1, tablet: 4, desktop: 5 }} className="custom-tile-containier">
                <CustomTileContainer
                          padding="1rem"
                          aspectRatio="none"
                          backgroundColor="gray"
                        >
                          <ImageContainer>
                            <img
                            height= {"90"}
                            width={"90"}
                            //src={getImageUrl(props?.aemContent?.smartPhoneImageFigmaUrl, 90, 90)}
                            src={getImage(props?.aemContent?.smartPhoneImageFigmaUrl,90,90)}
                          />
                          </ImageContainer>
                            <Body size="large" bold>
                              <div
                              dangerouslySetInnerHTML={{ __html: props?.aemContent?.smartPhoneHeading }}
                              ></div>
                            </Body>
                            <Body size={isMobile ? "medium" : "large"} color="#808080">
                              <div
                              dangerouslySetInnerHTML={{ __html: props?.aemContent?.smartPhoneContent }}
                              ></div>
                             </Body>
                </CustomTileContainer>
                </CustomColTile>
                </Row>
            </Grid>
            <MarginSpacerM />
                    <Body size="large">
                        <div
                            dangerouslySetInnerHTML={{ __html: props?.aemContent?.subHeading }}
                        ></div>
                    </Body>
                    <MarginSpacerM />
                    <Body size="large" bold={true}>
                        <div
                            dangerouslySetInnerHTML={{ __html: props?.aemContent?.listHeading }}
                        ></div>
                    </Body>
                    <MarginSpacerXS />
            {
                  <>
                    <div>
                      <>
                      <div style={{display: 'flex', flexDirection: "column"}}>
                        {props?.aemContent?.listContent?.map((element, idx) => {
                          return (
                              <div style={{paddingBottom: "16px"}}>
                                <Body size="large">
                                  {element}
                                </Body>
                              </div>
                          );
                        })}
                        </div>
                      </>
                    </div>
                  </>
            }
                        <>
                        <MarginSpacerM />
                        {props?.aemContent?.microContent?.map((element,id) =>{
                            return (
                                <>
                                <Micro size="large" color="#6F7171">
                                    <span dangerouslySetInnerHTML={{ __html: element }} />
                                </Micro>
                                <MarginSpacerM />
                                </>
                            )
                        })}
                        <MarginSpacerM />
                      </>
          </InternetGatewayModalBody>
        
        <ButtonContainer>
        <Button
          width={props?.isMobile ? "100%" : "140px"}
          onClick={() => {
            props.setShowModal(false);
          }}
          disabled={false}
        >
          Close
        </Button>
        </ButtonContainer>
      </IGModal>
  );
}
